import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';

import TicketNumberList from './TicketNumberList';
import {
  setTicketNumberObject,
} from '../actions';
import { queryAllTicketNumbersGQL } from '../graphql/index';
import { getTicketNumberId } from '../selectors';

const mapStateToProps = (state) => {
  return {
    selectedTicketNumberId: getTicketNumberId(state),
  };
};

const mapDispatchToProps = {
  setTicketNumberObjectAction: setTicketNumberObject,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withInit = lifecycle({
  componentWillMount() {
    const {
      allTicketNumbers,
      setTicketNumberObjectAction,
    } = this.props;

    if (allTicketNumbers.length > 0) {
      setTicketNumberObjectAction(allTicketNumbers[0]);
    }
  },
});

const enhance = compose(
  withRedux,
  queryAllTicketNumbersGQL,
  withInit,
);

export default enhance(TicketNumberList);
